<template>
  <div v-if="selectedPost">
    <transition
      name="reouter-anim"
      :duration="{enter: 800, leave: 300}"
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
      mode="out-in"
    >
      <moment-show :post="selectedPost" :key="this.$route.params.slug"></moment-show>
    </transition>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import MomentShow from "@/components/Posts/MomentShow";

export default {
  components: {
    MomentShow
  },
  computed: {
    ...mapState("posts", ["selectedPost"])
  },
  methods: {
    ...mapActions("posts", ["fetchPostVideo"])
  },
  mounted() {
    let postSlug = this.$route.params.slug;
    this.fetchPostVideo(postSlug);
  }
};
</script>